import {InfoCircle} from "flowbite-react-icons/outline";
import React, {useContext} from "react";
import {AlertTriangle} from "react-feather";
import {AuthContext} from "../../../context/AuthContext";
import {VendorNotificationTypes} from "../../../services/constants/Vendor/VendorNotificationTypes";

const CardExpiryNotification = ({type}) => {

    const {baseUrl} = useContext(AuthContext);
    const cardExpiryLink = `${baseUrl}/plan-and-payment-settings/open_update_cc`;

    if (type === VendorNotificationTypes.EXPIRING_SOON)
        return <div
            className={"sl-bg-warning-100 sl-flex-col sl-flex  sl-pt-10 sl-pb-10 justify-center sl-align-center "}>
            <div className={"sl-container"}>
                    <span className={"sl-flex sl-flex-row sl-gap-3 sl-font sl-text-sm sl-font-regular"}><InfoCircle
                        size={20}
                        color={"#475467"}/><span>
                         Your credit card will expire soon. To ensure uninterrupted access to all the benefits of Shortlister, please update your card. <a
                        className={"sl-font-semibold sl-underline"} href={cardExpiryLink}>Update now</a>
                    </span></span>
            </div>

        </div>;


    if (type === VendorNotificationTypes.EXPIRED)
        return <div className={"sl-bg-error-200 sl-flex-col sl-flex sl-pt-10 sl-pb-10 justify-center sl-align-center"}>
            <div className={"sl-container"}>
                    <span className={"sl-flex sl-flex-row sl-gap-3 sl-font sl-text-sm sl-font-regular"}><AlertTriangle
                        size={20}
                        color={"#475467"}/> <span>The credit card on your account has expired! To ensure uninterrupted access to all the benefits of Shortlister, please update your card.  <a
                        className={"sl-font-semibold sl-underline"} href={cardExpiryLink}>Update now</a></span></span>
            </div>
        </div>;

}


export default CardExpiryNotification

